import "./Treatments.module.css";
import Header from "@/reusable_sections/Header";
import ProfessionalHero from "./sections/ProfessionalHero";
import FiveWeekCourseDetails from "./sections/FiveWeekCourseDetails";
import TransparentPricing from "./sections/TransparentPricing";
import Footer from "@/reusable_sections/Footer";
export default function TreatmentsPage() {
  return <div>
      <Header />
      <ProfessionalHero />
      <FiveWeekCourseDetails />
      <TransparentPricing />
      <Footer />
    </div>;
}